export function NotFoundPage() {
  return (
    <div className='App'>
      <div className='w-screen h-screen grid place-content-center'>TODO: NOT FOUND</div>
    </div>
  );
}
